import { Component, ChangeDetectionStrategy } from "@angular/core";
import { ALLOWED_CHARACTERS } from "src/config/allowed-characters.config";
import { PrefixComponent } from "../../prefix.component";
import { TemplateDatetimeComponent } from "../../templates/template-datetime/template-datetime.component";

@Component({
  selector: "app-prefix-ti4",
  imports: [TemplateDatetimeComponent],
  templateUrl: "./prefix-ti4.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./prefix-ti4.component.less",
})
export class PrefixTi4Component extends PrefixComponent<string> {
  public constructor() {
    super();
    this.required = false;
    this.characters = ALLOWED_CHARACTERS["ti4"];
  }
}
